import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import preventReClick from "./directives";

/* vconsole-调试工具 */
// import VConsole from 'vconsole'
// const vConsole = new VConsole()
// Vue.use(vConsole)

/* 自定义-配置 */
import './libs/vantImport';

import './assets/styles/font.css';
import './assets/styles/reset.css';
import './assets/styles/common.css';


Vue.config.productionTip = false

new Vue({
  router,
  store,
  preventReClick,
  render: h => h(App)
}).$mount('#app')
